import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Appointments } from '@devexpress/dx-react-scheduler';
import { secondsInHour } from 'helpers/timeConsts';
import getWorkingDuration from 'components/ScheduleCalendar/getWorkingDuration';
import largeDurationTypeInHours from 'components/ScheduleCalendar/libComponents/AppointmentContentComponent/consts';

export default function AppointmentContentComponent({
  data,
  durationType,
}: Appointments.AppointmentContentProps) {
  const { t } = useTranslation();
  const secondsDuration = data.timeTo - data.timeFrom;
  return (
    <Stack
      direction={durationType === 'short' ? 'row' : 'column'}
      justifyContent="space-between"
      height="100%"
      py={secondsDuration >= secondsInHour * largeDurationTypeInHours ? 2 : 0}
      px={2}
    >
      <Stack>
        <Typography variant="body2" fontWeight={700} color="primary.dark">
          {t('project_tracking.work')}
        </Typography>
      </Stack>
      <Typography variant="body2" color="primary.dark">
        {getWorkingDuration(secondsDuration)}
      </Typography>
    </Stack>
  );
}
